import React from 'react';

export default function CancelIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 11c-2.8 0-5-2.2-5-5 0-1.4.6-2.7 1.5-3.6l6.6 7.5C8.2 10.6 7.2 11 6 11zm3.8-1.8L3.3 1.8C4.1 1.3 5 1 6 1c2.8 0 5 2.2 5 5 0 1.2-.5 2.3-1.2 3.2z"/></svg>
	);
}
